import { useState, useEffect, useContext } from "react";
import ListRequisicaoExames from "../../Lists/ListRequisicaoExames/ListRequisicaoExames";
import moment from "moment/moment";

import { AuthContext } from "../../../../../../shared/context/auth-context";

import toast from "react-hot-toast";
import { useLoading } from "../../../../../../shared/context/LoadingContext";

function RequsicaoExamesComponent({
  clienteId,
  sendRequest,
  token,
  dadosRequisicao,
}) {
  const { startLoading, stopLoading } = useLoading();
  const auth = useContext(AuthContext);
  const [requisicaoExames, setRequsicaoExames] = useState([]);

  useEffect(() => {
    const fetchRequsicaoExamesByCliente = async () => {
      startLoading();
      try {
        const responseData = await sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/requisicaoexames/cliente/${clienteId}`,
          "GET",
          null,
          {
            Authorization: "Bearer " + auth.token,
          }
        );
        const temp =
          responseData.requisicoes.length > 0
            ? responseData.requisicoes.sort((a, b) => {
                return new Date(b.createdAt) - new Date(a.createdAt);
              })
            : [];

        const requisicaoExames_com_data = temp.map((req) => {
          const data_requisicao = moment(req.createdAt).format(
            "DD-MM-YYYY / HH:mm:ss"
          );
          return (req = {
            ...req,
            data_requisicao: data_requisicao,
          });
        });

        setRequsicaoExames(requisicaoExames_com_data);
      } catch (err) {
        console.error("err", err);
      } finally {
        stopLoading();
      }
    };
    fetchRequsicaoExamesByCliente();
  }, [sendRequest, clienteId, auth.token]);

  const handleDesativar = async (id) => {
    startLoading();
    try {
      const formData = new FormData();
      formData.append("utilizador", auth.userId);
      await sendRequest(
        `${process.env.REACT_APP_BACKEND_LINK}/api/requisicaoexames/desativar/${id}`,
        "PATCH",
        formData,
        {
          Authorization: "Bearer " + token,
        }
      );
      setRequsicaoExames((currentRequsicaoExames) => {
        return currentRequsicaoExames.filter((el) => {
          return el._id !== id;
        });
      });

      toast.success("Desativação da requisição efetuada com sucesso!");
    } catch (err) {
      console.error("err", err);
    } finally {
      stopLoading();
    }
  };

  const requisicaoData = (
    cliente,
    clinica,
    medico_responsavel,
    dataRequisicao,
    examesSangue,
    examesUrina,
    fezes,
    fezesNota,
    naturalidade,
    procedencia,
    diagnostico
  ) => {
    const dados = {
      cliente,
      clinica,
      medico_responsavel,
      dataRequisicao,
      examesSangue,
      examesUrina,
      fezes,
      fezesNota,
      naturalidade,
      procedencia,
      diagnostico,
    };
    dadosRequisicao(dados);
  };

  const marcarEfetuado = async () => {};
  return (
    <>
      {requisicaoExames.length !== 0 && (
        <>
          <ListRequisicaoExames
            requisicaoData={requisicaoData}
            data={requisicaoExames}
            handleDesativar={handleDesativar}
            marcarEfetuado={marcarEfetuado}
          />
        </>
      )}
      {requisicaoExames.length === 0 && (
        <div className="no_data_div">Nenhuma requisição encontrada.</div>
      )}
    </>
  );
}

export default RequsicaoExamesComponent;
